const LOADER_HTML = `
  <!DOCTYPE html>
  <html>
  <head>
    <title>Generando PDF...</title>
    <style>
      body { font-family: Arial, sans-serif; display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; background: #f5f5f5; }
      .loader-container { text-align: center; }
      .spinner { border: 4px solid #e0e0e0; border-top: 4px solid #1976d2; border-radius: 50%; width: 50px; height: 50px; animation: spin 1s linear infinite; margin: 0 auto 20px; }
      @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      h2 { color: #333; margin-bottom: 10px; }
      p { color: #666; }
    </style>
  </head>
  <body>
    <div class="loader-container">
      <div class="spinner"></div>
      <h2>Generando PDF</h2>
      <p>Por favor espere, esto puede tomar unos segundos...</p>
    </div>
  </body>
  </html>
`;

// La ventana se abre de forma sincrona durante el click para que el navegador
// no la trate como popup no solicitado.
export function openPdfLoaderWindow() {
  const pdfWindow = window.open("", "_blank");
  if (pdfWindow) {
    pdfWindow.document.write(LOADER_HTML);
    pdfWindow.document.close();
  }
  return pdfWindow;
}

export function showPdfInWindow(pdfWindow, url) {
  if (pdfWindow) {
    pdfWindow.location.href = url;
  } else {
    window.open(url, "_blank");
  }
}

export function closePdfWindow(pdfWindow) {
  if (pdfWindow) {
    pdfWindow.close();
  }
}

export default { openPdfLoaderWindow, showPdfInWindow, closePdfWindow };
